import React from 'react';

import FulfillmentServiceDropdownContainer from '../../../../../fulfillment-planner/fulfillment-service/container';
import FulfillmentServiceLabel from '../../../../../fulfillment-planner/fulfillment-service/label';
import style from './style.module.less';

export const FulfillmentService = () => {
  return (
    <React.Fragment>
      <div className={style.label}>
        <FulfillmentServiceLabel />
      </div>
      <FulfillmentServiceDropdownContainer />
      <div />
    </React.Fragment>
  );
};
